"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 54.78 24",
    width: "54.78",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#93c01f"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m26.58 15.2h-3.22v-14.4a.8.8 0 0 0 -.8-.8h-22.56v19.83h8.49a.8.8 0 0 0 .66-.36 3.18 3.18 0 0 0 -.06.62 3.91 3.91 0 1 0 5.91-3.33h3.87a3.91 3.91 0 1 0 4.06 0h3.63a.78.78 0 0 0 0-1.56zm-17.28 3.67v-2.11h1.7a3.86 3.86 0 0 0 -1.7 2.11zm6 1.22a2.35 2.35 0 1 1 -2.3-2.35 2.35 2.35 0 0 1 2.35 2.35zm7.92 0a2.36 2.36 0 1 1 -2.37-2.35 2.35 2.35 0 0 1 2.4 2.3v.05z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m32.22 0a.8.8 0 0 0 -.8.8v14.4h-3.22a.78.78 0 0 0 0 1.56h3.63a3.92 3.92 0 1 0 5.38 1.32 3.88 3.88 0 0 0 -1.32-1.32h3.87a3.9 3.9 0 1 0 5.93 3.33 3.18 3.18 0 0 0 -.06-.62.78.78 0 0 0 .65.36h8.5v-19.83zm4 20.09a2.36 2.36 0 1 1 -2.37-2.35 2.36 2.36 0 0 1 2.37 2.35zm5.56 2.35a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1 -2.35 2.35zm3.7-3.57a3.91 3.91 0 0 0 -1.68-2.11h1.68z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m24.07 13.61a.5.5 0 0 1 -.24-.06.51.51 0 0 1 -.26-.44v-9.42a.48.48 0 0 1 .26-.43.4.4 0 0 1 .24-.07.59.59 0 0 1 .26.07l7.85 4.74a.51.51 0 0 1 0 .86l-7.85 4.71a.46.46 0 0 1 -.26.04z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m24.07 3.69 7.44 4.46.41.25-.41.25-7.44 4.46zm0-1a1.05 1.05 0 0 0 -.49.13 1 1 0 0 0 -.51.87v9.42a1 1 0 0 0 .51.87 1.05 1.05 0 0 0 .49.13 1.07 1.07 0 0 0 .52-.14l7.41-4.46.41-.25a1 1 0 0 0 0-1.72l-.41-.24-7.41-4.46a1 1 0 0 0 -.52-.15z",
    fill: "#fff"
  }));
};

exports["default"] = _default;